import * as S from "./styles";
export function TabMenu({ index, setIndex }) {
  return (
    <S.Container>
      <S.Button selected={index === 1 ? 1 : 0} onClick={() => setIndex(1)}>
        CASOS
      </S.Button>
      <S.Button selected={index === 2 ? 1 : 0} onClick={() => setIndex(2)}>
        INTERNAÇÕES
      </S.Button>
      <S.Button selected={index === 3 ? 1 : 0} onClick={() => setIndex(3)}>
        ÓBITOS
      </S.Button>
    </S.Container>
  );
}
